var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-icon-label"},[(_vm.icon)?_c('Icon',{staticClass:"ui-icon-label__icon",attrs:{"name":_vm.icon,"size":"s"}}):(_vm.picUrl)?_c('img',{staticClass:"ui-icon-label__pic",attrs:{"src":_vm.picUrl}}):_vm._e(),_c('span',{staticClass:"ui-icon-label__text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25f7811b","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/ui/label/icon-label.vue
// module id = 567
// module chunks = 0 1 2 3